module.exports = __webpack_public_path__ + "img/structure-organization-3.72e18ca6.jpg";